import httpClient, { ApiResponse } from "./httpClient";
import { Role } from "@/interfaces";

export const getAllRoles = async (): Promise<ApiResponse<Role>> =>
  httpClient.get("/roles");
